import { DATE_STRING_FORMAT } from 'utils/time/dateFormat.constants'
import { type ReportFilters } from '__codegen__/api'
import { type GeneratedReportsAddFormFilterValues } from 'legacy/sections/generated-reports/components/add/components/form/utils/generatedReportsAddForm.types'
import { dateRangeToStartEndDate } from 'legacy/common/utils/time/dateFormat'

// Our mutation filter shape varies from the form values filter shape,
// this will helper will form them accordingly
export const prepareFiltersForOnSubmit = (
  filters: GeneratedReportsAddFormFilterValues
): ReportFilters => {
  const shapedFilters: Required<ReportFilters> = {
    dateRange: {
      startDate: undefined,
      endDate: undefined,
    },
    retailerLocations: undefined,
  }

  if (filters.dateRange && filters.dateRange.dateRange) {
    if (filters.dateRange.dateRange === 'custom' && filters.dateRange.customDates) {
      const { startDate, endDate } = filters.dateRange.customDates
      shapedFilters.dateRange.startDate = startDate && startDate.format(DATE_STRING_FORMAT)
      shapedFilters.dateRange.endDate = endDate && endDate.format(DATE_STRING_FORMAT)
    } else {
      const { startDate, endDate } = dateRangeToStartEndDate({
        dateRange: filters.dateRange.dateRange,
      })
      shapedFilters.dateRange.startDate = startDate.format(DATE_STRING_FORMAT)
      shapedFilters.dateRange.endDate = endDate.format(DATE_STRING_FORMAT)
    }
  }

  // All locations maps to both of these values being null. Omit the filter entirely for that case.
  if (filters.retailerLocation?.retailerLocationId || filters.retailerLocation?.storeGroupId) {
    shapedFilters.retailerLocations = {
      retailerLocationIds: filters.retailerLocation.retailerLocationId && [
        filters.retailerLocation.retailerLocationId,
      ],
      retailerLocationGroupId: filters.retailerLocation.storeGroupId,
    }
  }

  return shapedFilters
}
